export class CartQf {
	constructor() {
		// Ensure window.QF.cart exists, fallback to empty cart if not
		this.cart = window.QF?.cart || {
			items: [],
			item_count: 0,
			total_price: 0
		};

		this.endpoints = {
			add: {
				url: 'cart/add.js',
				method: 'post'
			},
			get: {
				url: 'cart.js',
				method: 'get'
			},
			update: {
				url: 'cart/update.js',
				method: 'post'
			},
			change: {
				url: 'cart/change.js',
				method: 'post'
			},
			clear: {
				url: 'cart/clear.js',
				method: 'post'
			}
		};

		this.selectors = {
			cartContainer: '[cart-container]'
		};
	}

	dispatchEvent(event_name, includeCart) {
		let contents = null;
		if (includeCart) {
			contents = {
				detail: {
					cart: this.cart,
				},
			};
		}
		window.dispatchEvent(new CustomEvent(event_name, contents));
	}
	
	async add(data) {
		try {
			const responseData = await this.request('add', data);
			this.mergeWithCurrentCart(responseData);
			this.dispatchEvent("cart_changed", true);
			this.dispatchEvent("item_added", true);
			return this.cart;
		} catch (error) {
			throw error;
		}
	}

	async get() {
		try {
			const response = await this.request('get');
			this.cart = response.data;
			return this.cart;
		} catch (error) {
			throw error;
		}
	}

	async update(data) {
		try {
			const responseData = await this.request('update', data);
			this.cart = responseData;
			this.dispatchEvent("cart_changed", true);
			return this.cart;
		} catch (error) {
			throw error;
		}
	}

	async change(data) {
		try {
			const responseData = await this.request('change', data);
			this.cart = responseData;
			this.dispatchEvent("cart_changed", true);
			return this.cart;
		} catch (error) {
			throw error;
		}
	}

	async remove(variant_id) {
		try {
			const updates = {
				updates: {
					[variant_id]: 0,
				}
			};
			const { data: responseData } = await this.request('update', updates);
			this.cart = responseData;
			this.dispatchEvent("cart_changed", true);
			this.dispatchEvent("item_removed", true);
			return this.cart;
		} catch (error) {
			throw error;
		}
	}

	async clear() {
		try {
			const { data: responseData } = await this.request('clear');
			this.cart = responseData;
			this.dispatchEvent("cart_changed", true);
			this.dispatchEvent("cart_cleared", true);
			return this.cart;
		} catch (error) {
			throw error;
		}
	}

	async request(key, data) {
		try {
			const url = window.Shopify.routes.root + this.endpoints[key].url;
			const method = this.endpoints[key].method;
			const headers = {
				'Content-Type': 'application/json'
			};

			const response = await fetch(url, {
				method,
				headers,
				body: JSON.stringify(data)
			});


			if (response.ok) {
				return response.json();
			} else {
				throw await response.json();
			}
		} catch (error) {

			// Generate Toasty Message
			// let options = {
			//   title: error.message,
			//   message: error.description,
			//   delay: 5000
			// }
			//window.toasty.addToast(options);
			// console.log('🚀🚀🚀 ERROR: ', error);
			// console.log('🚀🚀🚀 DATA: ', data);

			throw error;
		}
	}

	mergeWithCurrentCart(data) {
		if (data.items) {
			data.items.forEach((item) => {
				let index = this.cart.items.findIndex(e => e.id === item.id);
				if (index > -1) {
					this.cart.items[index] = item;
				} else {
					this.cart.items.push(item);
				}
			});
		}
	}

	reRenderCart() {
		fetch(window.Shopify.routes.root + "cart?sections=hk-cart")
			.then((response) => {
				if (!response.ok) {
					throw new Error("Network response was not ok");
				}
				return response.json(); // Parse the response as JSON
			})
			.then((data) => {
				let html = data["hk-cart"];
				let cart_inner = document.querySelector(this.selectors.cartContainer);
				if (cart_inner && html) {
					cart_inner.innerHTML = html;
					this.cartRenderedEvent(html);
				}
			})
			.catch((error) => {
				console.error("Error:", error);
			});
	}

	cartRenderedEvent(response, html) {
		const event = new CustomEvent("cart_rendered", {
			detail: {
				response,
				html,
			},
		});
		window.dispatchEvent(event);
	}
}